jQuery(document).ready(function onMobileNavigationReady($) {
    "use strict";

    var $body = $('body');
    var $sidebar = $('.main-sidebar');
    var $header = $('.main-header');
    var $header_burger_button = $header.find('.main-header__content__burger-menu .burger');
    var $search_field = $header.find('.main-header__content__search-field input[type="text"]');
    var $search_submit_button = $header.find('.main-header__content__search-field button[type="submit"]');

    $header_burger_button.on('click', onClickBurgerMenu);
    $search_submit_button.on('click', onClickSearchSubmitButton);

    function onClickBurgerMenu(e) {
        e.preventDefault();

        $header_burger_button.toggleClass('burger--open');
        $sidebar.toggleClass('main-sidebar--open');
    }

    function onClickSearchSubmitButton(e) {
        var value = $search_field.val();
        if(value.trim().length === 0) {
            e.preventDefault();

            $header.toggleClass('main-header--search-toggled');
            return false;
        }
    }
});
